import { FC } from 'react';

import { NavigationNodeId, USER_ROLES } from '@pwc/pwc-deals-web-common';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import { useKFATitleI18n } from 'common/hooks/useKFATitleI18n';
import { getNavigationTitle } from 'common/helpers/getCustomNavigationTitles';
import { EmptyAnalysisType, GroupType } from '../../models/constants';

import './index.scss';

export type Props = {
  groupType: GroupType;
  groupsCount: number;
  analysisCount: number | undefined;
};

const EmptyMessage: FC<Props> = (props: Props) => {
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;
  const { t } = useTranslation();
  const KFATitle = getNavigationTitle(NavigationNodeId.KEY_FOCUS_AREAS);
  const KFATitleI18n = useKFATitleI18n(KFATitle);
  const { groupType, groupsCount, analysisCount } = props;
  const getEmptyMessageType = (): EmptyAnalysisType => {
    if (analysisCount === 0) {
      switch (groupType) {
        case 'custom':
        case 'none':
          return 'None';
        case 'kfa':
          return groupsCount === 0 ? 'NoAnalysesNoKFA' : 'NoKFA';
        default:
          return 'NotFound';
      }
    }
    return 'NotFound';
  };

  const getMessage = (emptyAnalysisType: EmptyAnalysisType): string => {
    switch (emptyAnalysisType) {
      case 'NoKFA':
        return t('noKFAsharedYet', { KFATitle: KFATitleI18n });
      case 'NoAnalysesNoKFA':
        return t('norAnalysesNorKFAsharedYet', { KFATitle: KFATitleI18n });
      case 'None':
        return t('noAnalysesSharedYet');
      default:
        return '';
    }
  };

  const emptyAnalysisType = getEmptyMessageType();
  const message = getMessage(emptyAnalysisType);
  return !isPwcUser && message ? (
    <div className="empty-message">{message}</div>
  ) : (
    <></>
  );
};

export default EmptyMessage;
